<!--
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-03-30 15:23:09
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-19 17:15:56
 -->
<template>
  <!-- <keep-alive> -->
    <router-view v-if="isRouterAlive" />
  <!-- </keep-alive> -->
</template>

<script>
// import common from '../../public/common.css'
export default {
  data() {
    return {
      isRouterAlive: true
    }
  },
  provide () {
    return {
      reload: this.reload
    }
  },
  created() {
    const userInfo = this.$storage.get('user_info')
    if (this.$router.path !== '/loginIndex' && userInfo) {
      this.$store.dispatch('initSwitch')
    }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}

</script>


<style lang="stylus">

body
  margin 0px
  padding 0px
  // font-family "Helvetica Neue,Helvetica,PingFang SC,Hiragino Sans GB,Microsoft YaHei,\\5FAE\8F6F\96C5\9ED1,Arial,sans-serif"
  font-size 14px
  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale
  font-family Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif
  line-height 1.14
  color #67757c
  background-color #fff
.el-button--medium
  padding 8px 10px
.el-button--mini
  padding 7px 8px
span.text-mono
  font-family "SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace"
  .iconBtns
    font-size 20px
    color rgba(0, 183, 158, 1)
#nprogress .bar
  background: #4EBDFF !important
</style>
